(() => {
  'use strict';
  const now = Date.now();
  const start = Date.parse('2026-10-24T00:00:00+07:00');
  const end = Date.parse('2026-10-26T00:00:00+07:00');
  if (now < start || now >= end || window.Shopify?.designMode) return;

  const configElement = document.getElementById('ving-event-language-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const visitKey = 'ving:event-20261024:language-initialized';
  // Record the first arrival before navigating, so subsequent language choices
  // are respected and a failed localization request cannot create a loop.
  try {
    if (sessionStorage.getItem(visitKey)) return;
    sessionStorage.setItem(visitKey, '1');
  } catch (_) {
    // Without session storage, keep the existing language rather than loop.
    return;
  }
  if (config.locale === 'en') return;

  const destination = new URL(window.location.href);
  const root = config.root.replace(/\/$/, '');
  if (root && (destination.pathname === root || destination.pathname.startsWith(root + '/'))) {
    destination.pathname = destination.pathname.slice(root.length) || '/';
  }
  destination.searchParams.delete('locale');
  destination.searchParams.delete('language');
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = '/localization';
  form.hidden = true;
  const fields = {
    form_type: 'localization',
    _method: 'put',
    language_code: 'en',
    return_to: destination.pathname + destination.search + destination.hash
  };
  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.append(input);
  }
  document.body.append(form);
  form.submit();
})();
